import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Loader } from "../../../common/Loader/Loader";
import { GetCompletedOrderslistBookingManagementSlice } from "../../../redux/features/BookingManagementSlice";
import Pagination from "../../../common/pagination/PaginationCustom";
import useParamsFormat from "../../../common/Params Values format/ParamsFormat";
import { toast } from "react-toastify";

const OrderCompleted = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const { createDataSetParams } = useParamsFormat();
  const [pagination, setPagination] = useState([]);
  const [handleArrforPage, setHandleArrforPage] = useState(1);
  const [arr, setArr] = useState([]);
  const [page, setPage] = useState(1);
  const [getSearch, setGetSearch] = useState({
    search: "",
    fromDate: "",
    toDate: "",
    page: 1,
  });

  const { loading } = useSelector((state) => state.BookingManagement);

  useEffect(() => {
    dispatch(GetCompletedOrderslistBookingManagementSlice()).then((res) => {
      console.log("res:", res);
      setData(res?.payload?.data);
      setPagination(res.payload.pagination);
    });
  }, []);

  useEffect(() => {
    if (Object.entries(pagination ?? {}).length > 0) {
      setArr(
        [...Array(pagination?.totalPages + 1).keys()]
          .slice(1)
          .slice(handleArrforPage - 1, handleArrforPage + 2)
      );
    }
  }, [pagination, handleArrforPage]);

  const handlePagesIncrease = () => {
    console.log("handleIncrease:", handleArrforPage);
    if (handleArrforPage + 3 <= pagination?.totalPages) {
      setHandleArrforPage((prev) => prev + 3);
    }
  };

  const handlePagesDecrease = () => {
    if (handleArrforPage > 2) {
      setHandleArrforPage((prev) => prev - 3);
    }
  };

  const FetchDataOnPages = (pageNum) => {
    setPage(pageNum);

    setGetSearch((prev) => ({ ...prev, page: pageNum }));

    const dataSet = createDataSetParams({ ...getSearch, page: pageNum });

    dispatch(GetCompletedOrderslistBookingManagementSlice(dataSet)).then(
      (res) => {
        const dummyData = res?.payload?.data;
        setData(dummyData);
        setPagination(res.payload.meta);
      }
    );
  };

  const HandleSearch = () => {
    //search=hello&fromDate=2024-12-05&toDate=2024-12-19&
    if (
      Object.entries(getSearch)
        .map(([key, value]) => value.length)
        .some((item) => item > 0)
    ) {
      if (
        ![getSearch.fromDate.length, getSearch.toDate.length].every(
          (item) => item === 0
        )
      ) {
        if (
          ![getSearch.fromDate.length, getSearch.toDate.length].every(
            (item) => item > 0
          )
        ) {
          toast.error("Please complete the date!");
          return;
        }
      }

      dispatch(
        GetCompletedOrderslistBookingManagementSlice(
          createDataSetParams(getSearch)
        )
      ).then((res) => {
        const dummyData = res?.payload?.data;
        setData(dummyData);
        setPagination(res.payload.pagination);
      });
    }
  };

  const HandleReset = () => {
    if (
      Object.entries(getSearch)
        .map(([key, value]) => value.length)
        .some((item) => item > 0)
    ) {
      setGetSearch({
        search: "",
        fromDate: "",
        toDate: "",
        page: 1,
      });

      dispatch(GetCompletedOrderslistBookingManagementSlice()).then((res) => {
        console.log("newsres", res);
        const dummyData = res?.payload?.data;
        setData(dummyData);
        setPagination(res.payload.pagination);
      });
    }
  };

  return (
    <>
      <>
        <>
          <div className="Small-Wrapper">
            <div className="Filter justify-content-between">
              <div className="Filter">
                <div className="form-group">
                  <label>Search</label>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search"
                    name="search"
                    value={getSearch?.search}
                    onChange={(e) =>
                      setGetSearch((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="form-group">
                  <label>From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="fromDate"
                    value={getSearch?.fromDate}
                    onChange={(e) =>
                      setGetSearch((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="form-group">
                  <label>To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={getSearch?.toDate}
                    name="toDate"
                    onChange={(e) =>
                      setGetSearch((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="Button"
                    style={{ marginRight: "10px" }}
                    onClick={HandleSearch}
                  >
                    Apply
                  </button>

                  <button className="Button Cancel" onClick={HandleReset}>
                    <i className="fa fa-refresh" />
                  </button>
                </div>
              </div>
              {/* <div className="FilterRight">
                <div className="form-group">
                  <label>Timeframe</label>
                  <select className="form-control">
                    <option value="select">--Select--</option>
                    <option value="select">Today</option>
                    <option value="Month">This Week</option>
                    <option value="Month">This Month</option>
                    <option value="Year">This Year</option>
                  </select>
                </div>
              </div> */}
            </div>
          </div>
          <div className="TableList">
            <table style={{ width: "160%" }}>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Booking Id</th>
                  <th>Booking Date &amp; Time</th>
                  <th>Customer id</th>
                  <th>Customer name</th>
                  <th>Customer contact details</th>
                  <th>Delivery address</th>
                  <th>Item quantity</th>
                  <th>Amount (in TZS)</th>
                  <th>Payment Mode</th>
                  <th>Payment Status</th>
                  <th>View Booking details</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <Loader />
                ) : Array.isArray(data) && data?.length > 0 ? ( 
                  data?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td> 
                          {(pagination?.currentPage - 1) * 10 + index + 1} 
                        </td>
                        <td>{item?.orderId}</td>
                        <td>{item?.createdAt?.slice(0, 10)}</td> 
                        <td>{item?.userId}</td>
                        <td>{item?.customerName}</td>
                        <td>{item?.altContact}</td>
                        <td style={{ width: 400 }}>
                          {item?.deliveryAddress?.street},
                          {item?.deliveryAddress?.pincode}
                        </td>
                        <td>{item?.itemQuantity}</td>
                        <td>{item?.totalAmount}</td>
                        <td>{item?.paymentMode}</td>
                        <td>
                          <span className="Green">{item?.paymentStatus}</span>
                        </td>
                        <td>
                          <div className="Actions">
                            <Link
                              className="Blue"
                              to={`/OrderManagment/OrderActiveConfirmDetails/${item?._id}`}
                            >
                              <i className="fa fa-eye" />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={13}>There is no data found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
        <div className="ModalBox">
          <div
            id="LogOutModal"
            className="modal fade"
            style={{ display: "none" }}
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="Decline">
                    <a
                      href="javascript:void(0);"
                      className="CloseModal"
                      data-dismiss="modal"
                    >
                      ×
                    </a>
                    <h3>Log Out</h3>
                    <p>Are you sure you want to logout?</p>
                    <h4>
                      <a href="javascript:void(0);" data-dismiss="modal">
                        no
                      </a>
                      <a href="login.html">Yes</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Pagination
            arr={arr}
            page={page}
            handlePagesIncrease={handlePagesIncrease}
            FetchDataOnPages={FetchDataOnPages}
            handlePagesDecrease={handlePagesDecrease}
          />
        </div>
      </>
    </>
  );
};

export default OrderCompleted;
